const DESIGN_SYSTEM_ICONS = {
  arrowDownSmall: require('static/design-system/icons/arrow-down-small.svg'),
  arrowLeft: require('static/design-system/icons/arrow-left.svg'),
  arrowLeftSmall: require('static/design-system/icons/arrow-left-small.svg'),
  arrowLineLeft: require('static/design-system/icons/arrowLine-left.svg'),
  arrowRightSmall: require('static/design-system/icons/arrow-right-small.svg'),
  arrowUpSmall: require('static/design-system/icons/arrow-up-small.svg'),
  bookmark: require('static/design-system/icons/bookmark.svg'),
  bookmarkFilled: require('static/design-system/icons/bookmark-filled.svg'),
  checkmark: require('static/design-system/icons/checkmark.svg'),
  childcare: require('static/design-system/icons/childcare.svg'),
  cross: require('static/design-system/icons/cross.svg'),
  currentLocation: require('static/design-system/icons/currentLocation.svg'),
  directions: require('static/design-system/icons/directions.svg'),
  facebook: require('static/design-system/icons/facebook.svg'),
  hairdryer: require('static/design-system/icons/hairdryer.svg'),
  heart: require('static/design-system/icons/heart.svg'),
  heartFilled: require('static/design-system/icons/heart-filled.svg'),
  instagram: require('static/design-system/icons/instagram.svg'),
  lookingGlass: require('static/design-system/icons/lookingGlass.svg'),
  pin: require('static/design-system/icons/pin.svg'),
  locker: require('static/design-system/icons/locker.svg'),
  mat: require('static/design-system/icons/mat.svg'),
  parking: require('static/design-system/icons/parking.svg'),
  phone: require('static/design-system/icons/phone.svg'),
  shower: require('static/design-system/icons/shower.svg'),
  toiletries: require('static/design-system/icons/toiletries.svg'),
  towel: require('static/design-system/icons/towel.svg'),
  transportation: require('static/design-system/icons/transportation.svg'),
  twitter: require('static/design-system/icons/twitter.svg'),
  web: require('static/design-system/icons/web.svg'),
};

const ILLUSTRATION_ICONS = {
  inactiveVenue: require('static/design-system/illustrations/inactive-venue.svg'),
};

const NUMBER_ICONS = {
  one: require('static/img/icon/numbers/one.svg'),
  two: require('static/img/icon/numbers/two.svg'),
  three: require('static/img/icon/numbers/three.svg'),
  four: require('static/img/icon/numbers/four.svg'),
  five: require('static/img/icon/numbers/five.svg'),
  six: require('static/img/icon/numbers/six.svg'),
};

const ARROW_ICONS = {
  arrow: require('static/img/arrow.svg'),
  arrowDownSmall: require('static/design-system/icons/arrow-down-small.svg'),
  arrowLeftSmall: require('static/design-system/icons/arrow-left-small.svg'),
  arrowLeft: require('static/design-system/icons/arrow-left.svg'),
  arrowLineLeft: require('static/design-system/icons/arrowLine-left.svg'),
  arrowRightSmall: require('static/design-system/icons/arrow-right-small.svg'),
  arrowUpSmall: require('static/design-system/icons/arrow-up-small.svg'),
};

const CIRCLE_ICONS = {
  'pointing-finger-circle': require('static/img/icon/circle/book.svg'),
  'checkmark-circle': require('static/img/icon/circle/check.svg'),
  'people-circle': require('static/img/icon/circle/friends.svg'),
  'calendar-circle': require('static/img/icon/circle/routine.svg'),
  'magnifying-glass-circle': require('static/img/icon/circle/search.svg'),
  'dumbbell-circle': require('static/img/icon/circle/weight.svg'),
  'no-limits-circle': require('static/img/icon/circle/no-limits.svg'),
};

const TILE_ICONS = {
  calendar: require('static/img/icon/calendar-outline-blue.svg'),
  checkmark: require('static/img/icon/checkmark-outline-blue.svg'),
  dumbbell: require('static/img/icon/dumbbell-outline-blue.svg'),
  'key-white': require('static/img/icon/key-white.svg'),
  'magnifying-glass': require('static/img/icon/magnifying-glass-outline-blue.svg'),
  muscle: require('static/img/icon/muscle.svg'),
  'muscle-white': require('static/img/icon/muscle-white.svg'),
  people: require('static/img/icon/people-outline-blue.svg'),
  'pointing-finger': require('static/img/icon/pointing-finger-outline-blue.svg'),
  unlocked: require('static/img/icon/unlocked.svg'),
  'unlocked-white': require('static/img/icon/unlocked-white.svg'),
  video: require('static/img/icon/video.svg'),
};

const LINEART_BLUE = {
  map_pin: require('static/img/icon/lineart-blue-map-pin.svg'),
};

const ACTIVITY_ICONS = {
  fitness: require('static/img/icon/fitness.svg'),
  gym: require('static/img/icon/gym.svg'),
  wellness: require('static/img/icon/wellness.svg'),
  all: DESIGN_SYSTEM_ICONS.lookingGlass,
  default: require('static/img/icon/gym.svg'),
};

const SOCIAL_SHARE_ICONS = {
  facebook: require('static/img/icon/social-facebook.svg'),
  instagram: require('static/img/icon/social-instagram.svg'),
  twitter: require('static/img/icon/social-twitter.svg'),
  linkedin: require('static/img/icon/social-linkedin.svg'),
  email: require('static/img/icon/social-email.svg'),
  copy: require('static/img/icon/social-copy.svg'),
};

const FILTER_ICONS = {
  checkmark: require('static/img/icon/checkmark-new.svg'),
};

const STYLE_GUIDE = {
  calendar: require('style-guide/templates/static/assets/images/css/icons/calendar.svg'),
};

export {
  DESIGN_SYSTEM_ICONS,
  ILLUSTRATION_ICONS,
  NUMBER_ICONS,
  ARROW_ICONS,
  CIRCLE_ICONS,
  TILE_ICONS,
  LINEART_BLUE,
  ACTIVITY_ICONS,
  SOCIAL_SHARE_ICONS,
  FILTER_ICONS,
  STYLE_GUIDE,
};
